module.exports = {"checkbox":{"label":"Tôi đồng ý với tất cả <a href=\"#\">Điều khoản</a>"},"modal":{"reject":"Từ chối","accept":"Chấp nhận"}};